import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../utils/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

function CardRoot({ className, children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-xl border border-hilevel-border bg-white shadow-sm overflow-hidden',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

function CardHeader({ className, children, ...rest }: CardProps) {
  return (
    <header
      className={cn('border-b border-hilevel-border bg-hilevel-offwhite px-5 py-3', className)}
      {...rest}
    >
      <h2 className="text-sm font-semibold uppercase tracking-wider text-hilevel-gray">
        {children}
      </h2>
    </header>
  );
}

function CardBody({ className, children, ...rest }: CardProps) {
  return (
    <div className={cn('p-5', className)} {...rest}>
      {children}
    </div>
  );
}

export const Card = Object.assign(CardRoot, { Header: CardHeader, Body: CardBody });
